import { Box, Stack } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

interface IconBoxProps {
  icon: React.ElementType<SvgIconProps>;
  size?: number;
}

const NonCashBenefitStatusIcon: React.FC<IconBoxProps> = ({ icon: Icon, size = 50 }) => {
  return (
    <Stack
      spacing={1}
      direction={'column'}
      sx={{
        alignItems: 'center',
        width: '100%',
        height: 100,
      }}
    >
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: '30%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: 3,
          bgcolor: 'background.default',
        }}
      >
        <Icon sx={{ fontSize: size }} />
      </Box>
    </Stack>
  );
};

export default NonCashBenefitStatusIcon;
